import { RepositoryFactory } from '@/repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '@/services/CredentialsService.js'

const RankingRepository = RepositoryFactory.get('ranking')

class RankingService {
  static async getRanking (params) {
    try {
      return await RankingRepository.getRanking(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }

  static async getRankingHorses (params) {
    try {
      return await RankingRepository.getRankingHorses(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }

  static async getRankingRiders (params) {
    try {
      return await RankingRepository.getRankingRiders(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }

  static async exportRanking (params) {
    try {
      return await RankingRepository.exportRanking(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }

  static async exportRankingHorses (params) {
    try {
      return await RankingRepository.exportRankingHorses(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }

  static async exportRankingRiders (params) {
    try {
      return await RankingRepository.exportRankingRiders(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }
}

export default RankingService
